import { AgentAdminPage } from './AgentAdminPage'

export function AdminSyncPage() {
  return <AgentAdminPage mode="sync" />
}
